/**
 * Mockup Renderer
 * Renders the appropriate mockup component based on mockup ID
 */

import React from 'react';
import type { MockupConfig } from './types';
import {
  MooncloakSearchMockup,
  MooncloakGameDayMockup,
  FacebookFeedMockup,
  InstagramFeedMockup,
  InstagramStoryMockup,
  GoogleDisplayMockup,
  TwitterFeedMockup,
} from './platforms';

interface MockupRendererProps {
  mockup: MockupConfig;
  children: React.ReactNode;
  adWidth: number;
  adHeight: number;
}

export function MockupRenderer({ mockup, children, adWidth, adHeight }: MockupRendererProps) {
  const props = { children, adWidth, adHeight };

  switch (mockup.id) {
    case 'mooncloak-search':
      return <MooncloakSearchMockup {...props} />;
    case 'mooncloak-homepage':
      return <MooncloakSearchMockup {...props} />; // Reuse search mockup for now
    case 'mooncloak-gameday':
      return <MooncloakGameDayMockup {...props} />;
    case 'facebook-feed':
      return <FacebookFeedMockup {...props} />;
    case 'instagram-feed':
      return <InstagramFeedMockup {...props} />;
    case 'instagram-story':
      return <InstagramStoryMockup {...props} />;
    case 'google-search':
    case 'google-display':
      return <GoogleDisplayMockup {...props} />;
    case 'twitter-feed':
      return <TwitterFeedMockup {...props} />;
    default:
      // Fallback: just render the ad without mockup
      return <div className="inline-block">{children}</div>;
  }
}
